import React, { forwardRef } from 'react';
// import moment from 'moment';
import { ReadNumber } from '~commons/read-number';

const OilSupplyTicket = forwardRef(({ itemSelectedToPrint, companyInfo }, ref) => {
  const convertNumberToText = (number) => {
    const isNumberType = Number?.isInteger(number);
    if (isNumberType) return ReadNumber(number);

    const getFloor = number.toString().split('.');
    const intNumber = ReadNumber(parseInt(getFloor[0]));
    const floorNumber = ReadNumber(parseInt(getFloor[1]));
    return `${intNumber} Chấm ${floorNumber}`;
  };

  const renderOilTicket = (dataRender) => {
    const dataNumberCode = dataRender?.numberCode?.split('U&I');
    const displayNumberCode = dataNumberCode ? `${dataNumberCode[0]} U&I ${dataNumberCode[1]}` : '';

    const driverMain = dataRender?.driverMainName;
    const carCode = dataRender?.carCode;

    const dateFormat = `${dataRender?.assignOn[0]}${dataRender?.assignOn[1]}`;
    const mothFormat = `${dataRender?.assignOn[3]}${dataRender?.assignOn[4]}`;
    const yearFormat = `${dataRender?.assignOn[6]}${dataRender?.assignOn[7]}${dataRender?.assignOn[8]}${dataRender?.assignOn[9]}`;

    return (
      <div style={{ border: '2px solid blue', marginLeft: '20px', width: '50%' }}>
        <div style={{ paddingLeft: '10px' }}>{dataRender?.companyName ?? companyInfo?.name}</div>
        <div
          style={{
            textAlign: 'center',
          }}
        >
          <b>PHIẾU CẤP NHIÊN LIỆU</b>
          <div>Số: {displayNumberCode} </div>
        </div>

        <div>
          <div style={{ padding: '0px 0px  0px 30px', margin: '0px' }}>
            <span>- Kính Gửi: Cửa Hàng Xăng Dầu</span>
            <div>- Chúng Tôi Đề Nghị Cửa Hàng Cấp Cho:</div>
          </div>

          <div style={{ border: '2px solid red', margin: '0px 10px', paddingLeft: '10px' }}>
            <span>- Lái Xe: </span>
            <b>{driverMain}</b>
            <br />
            <span>- Số Xe: </span>
            <b>{carCode}</b>
            <br />
            <span>- Lý Do: </span>
            <b>Chi Dầu Ngày {dataRender?.assignOn}</b>
            <br />
            <span>- Số Lượng: </span>
            <b>{Math.round(dataRender?.newOilToSupply)}</b> Lít{' '}
            {dataRender?.totalOilSupport > 0 && (
              <span>(bao gồm {dataRender?.totalOilSupport} Lít hỗ trợ)</span>
            )}
            <br />
            <span>- Bằng Chữ: </span>
            <b>{convertNumberToText(Math.round(dataRender?.newOilToSupply))}</b>
            <br />
            <span>- Ngày Cấp: </span>
            <b>{`${dateFormat}/${mothFormat}/${yearFormat}`}</b>
            <br />
            <b>Phiếu có giá trị trong 3 ngày kể từ ngày cấp.</b>
          </div>
          <div style={{ display: 'flex' }}>
            <div style={{ marginLeft: 'auto', paddingRight: '20px' }}>
              Ngày {dateFormat} Tháng {mothFormat} Năm {yearFormat}
            </div>
          </div>
          <div
            style={{
              display: 'flex',
              textAlign: 'center',
              alignItems: 'center',
              marginBottom: '40px',
            }}
          >
            <div style={{ width: '32%', fontWeight: 'bold' }}>Duyệt</div>
            <div style={{ width: '32%', fontWeight: 'bold' }}>Lập phiếu</div>
            <div style={{ width: '32%', fontWeight: 'bold' }}>Lái Xe</div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div ref={ref} style={{ display: 'flex' }}>
      {renderOilTicket(itemSelectedToPrint)}
      {renderOilTicket(itemSelectedToPrint)}
    </div>
  );
});

export { OilSupplyTicket };
